import { BoletagemAnexo } from '../boletagem-anexo';
import { BoletagemIndexacao } from '../boletagem-indexacao';
import { BoletagemPagamento } from '../boletagem-pagamento';
import { BoletagemProduto } from '../boletagem-produto';
import { BoletagemSazonalidade } from '../boletagem-sazonalidade';
import { Contraparte } from '../contraparte';
import { ContraparteCCEE } from '../contraparte-ccee';
import { Distribuidora } from '../distribuidoras';
import { GestoraEnergia } from '../gestora-energia';
import { TipoEnergia } from '../tipo-energia';
import { Usuario } from '../usuario';

export enum GarantiaStatus {
  PENDENTE = 'P',
  APROVADO = 'A',
  RECUSADO = 'R'
}

export enum BoletagemDesconto {
  I0 = 'I0',
  I50 = 'I50',
  I80 = 'I80',
  I100 = 'I100',
  CQ5 = 'CQ5'
}

export enum BoletagemStatus {
  'Pendente' = 'P',
  'Aprovado' = 'A',
  'Reprovado' = 'R',
  'Em Análise' = 'E',
  'Inativado' = 'I',
  'Cancelado' = 'C'
}

export enum BoletagemCompraVenda {
  'Compra' = 'C',
  'Venda' = 'V'
}

export enum BoletagemPrePago {
  'Não' = 'N',
  'Sim' = 'S'
}

export enum BoletagemTipo {
  CP = 'CP',
  LP = 'LP'
}

export enum BoletagemSubMercado {
  'Sul' = 'S',
  'Sudeste' = 'SE',
  'Norte' = 'N',
  'Nordeste' = 'NE'
}

export enum BoletagemTipoGarantia {
  'Carta Fiança' = 'Carta Fiança',
  'Seguro Garantia' = 'Seguro Garantia',
  'Depósito Caução' = 'Depósito Caução',
  Outros = 'Outros'
}

export enum BoletagemTipoIndexacao {
  IPCA = 'IPCA',
  IGPM = 'IGP-M',
  OUTRO = 'Outro'
}

export enum BoletagemTipoDiaPagamento {
  'Dia Corrido' = 'Dia Corrido',
  'Dia Útil' = 'Dia Útil'
}

export enum GrandezaEnergia {
  MWm = 'MWm',
  MWh = 'MWh'
}

export enum BoletagemConfirmacao {
  BBCE = 'BBCE',
  EMAIL = 'EMAIL',
  LEILÃO = 'LEILAO',
  MVE = 'MVE'
}

export enum BoletagemTipoContrato {
  'PLD +' = 'PLD +',
  'Preço Fixo' = 'Preço Fixo'
}

export enum BoletagemJuridicoStatus {
  'Elaboração' = 'E',
  'Aguardando Assinatura' = 'P',
  'Assinado' = 'A',
  'Analise Contraparte' = 'C',
  'Sem resposta' = 'S'
}

export enum BoletagemGarantiaValidadeStatus {
  'Executada' = 'L',
  'Vencida' = 'E',
  'Válida' = 'V'
}

export enum BoletagemDescontoComissao {
  'Não' = 'N',
  'Sim' = 'S'
}

export interface Boletagem {
  readonly id?: number | null;
  readonly codigo?: string | null;
  readonly contraparte?: Contraparte | null;
  readonly ccee?: ContraparteCCEE | null;
  readonly tipoEnergia?: TipoEnergia | null;
  readonly desconto?: BoletagemDesconto | null;
  readonly tipoContrato?: BoletagemTipoContrato | null;
  readonly compraVenda?: BoletagemCompraVenda | null;
  readonly mesLiquidacao?: number | null;
  readonly tipoDiaLiquidacao?: string | null;
  readonly diaLiquidacao?: number | null;
  readonly confirmacao?: BoletagemConfirmacao | null;
  readonly flexibilidade?: boolean | null;
  readonly valorFlexibilidadeMais?: number | null;
  readonly valorFlexibilidadeMenos?: number | null;
  readonly sazonalidade?: boolean | null;
  readonly garantia?: boolean | null;
  readonly obsGarantia?: string | null;
  readonly tipoGarantia?: string | null;
  readonly tipoGarantiaOutro?: string | null;
  readonly prazoDeposito?: string | null;
  readonly statusGarantia?: GarantiaStatus | null;
  readonly valorGarantia?: number | null;
  readonly usuarioStatusGarantia?: Usuario | null;
  readonly dataStatusGarantia?: string | null;
  readonly garantiaExecutada?: boolean | null;
  readonly vigencia?: string | null;
  readonly cobertura?: number | null;
  readonly status?: BoletagemStatus | null;
  readonly usuario?: Usuario | null;
  readonly usuarioStatus?: Usuario | null;
  readonly motivoRecusa?: string | null;
  readonly dataInclusao?: string | null;
  readonly dataStatus?: string | null;
  readonly valorSazonalidadeMenos?: number | null;
  readonly valorSazonalidadeMais?: number | null;
  readonly dataDeclaracaoSazonalidade?: string | null;
  readonly statusSazonalidade?: string | null;
  readonly usuarioStatusSazonalidade?: Usuario | null;
  readonly dataStatusSazonalidade?: string | null;
  readonly retusd?: number | null;
  readonly subMercado?: BoletagemSubMercado | null;
  readonly indexacao?: boolean | null;
  readonly tipoIndexacao?: BoletagemTipoIndexacao | null;
  readonly tipoIndexacaoOutro?: string | null;
  readonly dataBaseIndexacao?: string | null;
  readonly obsIndexacao?: string | null;
  readonly obs?: string | null;
  readonly numContratoBBCE?: string | null;
  readonly registroContraPagamento?: boolean | null;
  readonly cliqCCEE?: string | null;
  readonly prepago?: BoletagemPrePago | null;
  readonly indexacaos?: BoletagemIndexacao[] | null;
  readonly produtos?: BoletagemProduto[] | null;
  readonly anoMesInicio?: string | null;
  readonly anoMesFim?: string | null;
  readonly volumeEnergiaMedio?: number | null;
  readonly volumeEnergiaHora?: number | null;
  readonly preco?: number | null;
  readonly precoTotal?: number | null;
  readonly spreadServicosComissao?: number | null;
  readonly sazonalidades?: BoletagemSazonalidade[] | null;
  readonly pagamentos?: BoletagemPagamento[] | null;
  readonly anexos?: BoletagemAnexo[] | null;
  readonly tipo?: BoletagemTipo | null;
  readonly encargos?: number | null;
  readonly inadimplencia?: number | null;
  readonly gestora?: GestoraEnergia | null;
  readonly juridicoStatus?: BoletagemJuridicoStatus | null;
  readonly distribuidora?: Distribuidora | null;
  readonly varejista?: boolean | null;
  readonly descontoGarantido?: boolean | null;
  readonly valorDescontoGarantido?: number | null;
  readonly comissaoDesconto?: BoletagemDescontoComissao | null;
  readonly valorComissaoDesconto?: number | null;
  readonly idDistribuidora?: number | null;
  readonly comissaoServicos?: number | null;
  readonly IdEmpresa?: number | null;
}
